import { render } from "./group_examine.vue?vue&type=template&id=b2c4d5a2"
import script from "./group_examine.vue?vue&type=script&lang=js"
export * from "./group_examine.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__